var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "sdetails-dialog",
          attrs: {
            visible: _vm.sdetailsDialog,
            width: "600px",
            title: "全证据链"
          },
          on: {
            "update:visible": function($event) {
              _vm.sdetailsDialog = $event
            },
            open: _vm.openDialog,
            close: _vm.closeDialog
          }
        },
        [
          _vm.applySignRecord && _vm.applySignRecord.length > 0
            ? _c(
                "div",
                { staticClass: "sdetails" },
                [
                  _vm._l(_vm.applySignRecord, function(item, index) {
                    return [
                      item.signType !== 11
                        ? _c(
                            "div",
                            { key: index, staticClass: "sdetails-item" },
                            [
                              item.signType == 1
                                ? _c("h5", [_vm._v("签署方")])
                                : _vm._e(),
                              item.signType == 14
                                ? _c("h5", [_vm._v("发起方")])
                                : _vm._e(),
                              item.signType == 16
                                ? _c("h5", [
                                    _vm._v(
                                      "\n            发起方（" +
                                        _vm._s(item.identityCard) +
                                        "）\n            "
                                    ),
                                    _c("span", [_vm._v("发起撤销")])
                                  ])
                                : _vm._e(),
                              item.signType === 18
                                ? _c("h5", [_vm._v("确认签署")])
                                : _vm._e(),
                              item.signType === 20
                                ? _c("h5", [_vm._v("催签")])
                                : _vm._e(),
                              item.signType === 23
                                ? _c("h5", [_vm._v("注册认证信息")])
                                : _vm._e(),
                              item.signType !== 24
                                ? [
                                    _c(
                                      "p",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: item.identityCard,
                                            expression: "item.identityCard"
                                          }
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          "证件号：" + _vm._s(item.identityCard)
                                        )
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: item.name,
                                            expression: "item.name"
                                          }
                                        ]
                                      },
                                      [_vm._v("名称：" + _vm._s(item.name))]
                                    )
                                  ]
                                : _vm._e(),
                              item.signType == 1
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("p", [
                                      _vm._v("终端IP：" + _vm._s(item.ip))
                                    ]),
                                    _c("p", [
                                      _vm._v("地址：" + _vm._s(item.url))
                                    ]),
                                    item.userAgent && item.userAgent != ""
                                      ? _c("p", [
                                          _vm._v(
                                            "浏览器UA：" +
                                              _vm._s(item.userAgent)
                                          )
                                        ])
                                      : _vm._e(),
                                    item.addr
                                      ? _c("p", [
                                          _vm._v(
                                            "地理位置：" + _vm._s(item.addr)
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                : item.signType == 2
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("p", [_vm._v("身份认证")]),
                                    _c("p", [
                                      _vm._v("认证方式：" + _vm._s(item.bank))
                                    ]),
                                    _c("p", [
                                      _vm._v("认证信息：" + _vm._s(item.cardNo))
                                    ]),
                                    _c("p", [
                                      _vm._v("流水号:" + _vm._s(item.orderNo))
                                    ]),
                                    _c("p", [_vm._v("验证成功.")])
                                  ]
                                : item.signType == 3
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("p", [_vm._v("身份认证")]),
                                    _c("br"),
                                    _c("p", [_vm._v("认证方式：银行U盾")]),
                                    _c("p", [
                                      _vm._v("流水号:" + _vm._s(item.orderNo))
                                    ])
                                  ]
                                : item.signType == 4
                                ? [
                                    item.signRefcode
                                      ? _c("p", [
                                          _vm._v(
                                            "CA证书序列号：" +
                                              _vm._s(item.signRefcode)
                                          )
                                        ])
                                      : _vm._e(),
                                    item.signStartTime && item.signExpireTime
                                      ? _c("p", [
                                          _vm._v(
                                            "\n              CA证书有效期：" +
                                              _vm._s(item.signStartTime) +
                                              " 至\n              " +
                                              _vm._s(item.signExpireTime) +
                                              "\n            "
                                          )
                                        ])
                                      : _vm._e(),
                                    item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    item.signingTipsContent
                                      ? _c("p", [
                                          _vm._v(
                                            "已阅读并确认：" +
                                              _vm._s(item.signingTipsContent)
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("b", [
                                      _vm._v(_vm._s(item.name) + " 签署完成")
                                    ]),
                                    _c("br"),
                                    item.contractNames &&
                                    item.contractNames.length > 0
                                      ? _c("p", [_vm._v("文件名称：")])
                                      : _vm._e(),
                                    _vm._l(item.contractNames, function(v, i) {
                                      return _c("p", { key: i }, [
                                        _vm._v(_vm._s(v))
                                      ])
                                    }),
                                    item.addr
                                      ? _c("p", [
                                          _vm._v(
                                            "地理位置：" + _vm._s(item.addr)
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("div", [
                                      _vm._v(
                                        "系统已自动将签署证据提交至第三方机构（保全中心、公证处、司法鉴定中心等）"
                                      )
                                    ])
                                  ]
                                : item.signType == 23
                                ? [
                                    _c("b", [
                                      _vm._v(
                                        "认证方式:" +
                                          _vm._s(
                                            _vm.fluStatus(
                                              item.authType,
                                              item.userType
                                            )
                                          )
                                      )
                                    ]),
                                    _c("br"),
                                    _c("p", [
                                      _vm._v(
                                        "认证时间：" + _vm._s(item.authDate)
                                      )
                                    ]),
                                    _c("p", [
                                      _vm._v("流水号：" + _vm._s(item.orderNo))
                                    ]),
                                    item.authType == 1 && item.context
                                      ? _c("p", [
                                          _vm._v(
                                            "匹配百分比：" +
                                              _vm._s(item.context) +
                                              "%"
                                          )
                                        ])
                                      : _c("p", [_vm._v("认证结果：通过")])
                                  ]
                                : item.signType == 5
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("b", [_vm._v("拒签")]),
                                    _c("p", [
                                      _vm._v(
                                        "\n              拒签理由：\n              " +
                                          _vm._s(item.context) +
                                          "\n            "
                                      )
                                    ]),
                                    item.addr
                                      ? _c("p", [
                                          _vm._v(
                                            "地理位置：" + _vm._s(item.addr)
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                : item.signType == 6
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("b", [_vm._v("存证成功")]),
                                    _c("br"),
                                    _c("p", [
                                      _vm._v(
                                        "上传" +
                                          _vm._s(item.fileName) +
                                          "成功，Hash值：" +
                                          _vm._s(item.docHash)
                                      )
                                    ])
                                  ]
                                : item.signType == 7
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("b", [_vm._v("删除存证")]),
                                    _c("br"),
                                    _c("p", [
                                      _vm._v(
                                        "删除" +
                                          _vm._s(item.fileName) +
                                          "成功，Hash值：" +
                                          _vm._s(item.docHash)
                                      )
                                    ])
                                  ]
                                : item.signType == 8
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("b", { staticClass: "color-primary" }, [
                                      _vm._v(
                                        "存证成功(" +
                                          _vm._s(item.storeType) +
                                          ")"
                                      )
                                    ]),
                                    _c("br"),
                                    _c("div", [
                                      _vm._v("备案号：" + _vm._s(item.presId))
                                    ])
                                  ]
                                : item.signType == 9
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("b", [_vm._v("备注")]),
                                    _c("br"),
                                    _c("p", [_vm._v(_vm._s(item.context))])
                                  ]
                                : item.signType == 10
                                ? [
                                    _c("b", [_vm._v("人脸识别认证")]),
                                    _c("br"),
                                    _c("p", [
                                      _vm._v(
                                        "\n              认证时间：" +
                                          _vm._s(
                                            _vm._f("formatDateTime")(
                                              !item.faceTime
                                                ? item.createTime
                                                : item.faceTime
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]),
                                    _c("p", [
                                      _vm._v("流水号:" + _vm._s(item.orderNo))
                                    ]),
                                    item.faceAuthName && item.faceAuthIdNo
                                      ? _c("p", [
                                          _vm._v(
                                            "授权人:" +
                                              _vm._s(item.faceAuthName) +
                                              "(" +
                                              _vm._s(item.faceAuthIdNo) +
                                              ")"
                                          )
                                        ])
                                      : _vm._e(),
                                    item.context
                                      ? _c("p", [
                                          _vm._v(
                                            "匹配百分比:" +
                                              _vm._s(
                                                parseFloat(
                                                  item.context
                                                ).toFixed(2) + "%"
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    item.docHash
                                      ? _c("p", [
                                          _vm._v(
                                            "人脸识别视频存证成功,Hash值:" +
                                              _vm._s(item.docHash)
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                : item.signType == 12
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("b", [_vm._v("转签")]),
                                    _c("br"),
                                    _c("div", [_vm._v(_vm._s(item.context))])
                                  ]
                                : item.signType == 13
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("div", [
                                      _vm._v(
                                        "\n              本次签署为连续签署，上一份签署【" +
                                          _vm._s(item.context) +
                                          "】已完成签署并记录签署日志（连续签署必须按照顺序依次连续完成签署，不可中途中断签署或跳过第一份文件进行签署，身份验证适用于每一份连续签署）。\n            "
                                      )
                                    ])
                                  ]
                                : item.signType == 14
                                ? [
                                    _c("p", [
                                      _vm._v("终端IP：" + _vm._s(item.ip))
                                    ]),
                                    _c("p", [
                                      _vm._v("地址：" + _vm._s(item.url))
                                    ]),
                                    item.userAgent
                                      ? _c("p", [
                                          _vm._v(
                                            "浏览器UA：" +
                                              _vm._s(item.userAgent)
                                          )
                                        ])
                                      : _vm._e(),
                                    item.addr
                                      ? _c("p", [
                                          _vm._v(
                                            "地理位置：" + _vm._s(item.addr)
                                          )
                                        ])
                                      : _vm._e(),
                                    item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    item.themeName
                                      ? _c("b", [_vm._v("发起文件")])
                                      : _vm._e(),
                                    _c("br"),
                                    item.themeName
                                      ? _c("p", [
                                          _vm._v(
                                            "主题名称：" +
                                              _vm._s(item.themeName)
                                          )
                                        ])
                                      : _vm._e(),
                                    item.contractNames &&
                                    item.contractNames.length > 0
                                      ? _c("p", [_vm._v("文件名称：")])
                                      : _vm._e(),
                                    _vm._l(item.contractNames, function(v, i) {
                                      return _c("p", { key: i }, [
                                        _vm._v(_vm._s(v))
                                      ])
                                    }),
                                    item.readTimeSignInfoList &&
                                    item.readTimeSignInfoList.length
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            item.readTimeSignInfoList,
                                            function(childItem, childIndex) {
                                              return _c(
                                                "p",
                                                { key: "xxx" + childIndex },
                                                [
                                                  _vm._v(
                                                    "发起方给签署方（" +
                                                      _vm._s(childItem.name) +
                                                      "）设置了" +
                                                      _vm._s(
                                                        childItem.readTime
                                                      ) +
                                                      "s强制阅读"
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                    _vm.isAttend
                                      ? _c("b", [_vm._v("上传附属材料")])
                                      : _vm._e(),
                                    _c("br"),
                                    _vm._l(_vm.applySignRecord, function(
                                      file,
                                      i
                                    ) {
                                      return [
                                        _c(
                                          "div",
                                          { key: "xx" + i },
                                          [
                                            file.signType == 11
                                              ? [
                                                  _c("p", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          file.sourceName
                                                        ) +
                                                        "，上传" +
                                                        _vm._s(file.fileName) +
                                                        "成功，Hash值：" +
                                                        _vm._s(file.docHash) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ]
                                    }),
                                    item.notify && item.notify.length > 0
                                      ? _c("b", [_vm._v("签署通知")])
                                      : _vm._e(),
                                    item.notify && item.notify.length > 0
                                      ? _vm._l(item.notify, function(elem) {
                                          return _c("div", { key: elem.idNo }, [
                                            _c("p", [
                                              _vm._v(
                                                "证件号：" + _vm._s(elem.idNo)
                                              )
                                            ]),
                                            _c("p", [
                                              _vm._v(
                                                "名称：" + _vm._s(elem.name)
                                              )
                                            ]),
                                            _c("p", [
                                              _vm._v(
                                                "时间：" +
                                                  _vm._s(elem.createTime)
                                              )
                                            ]),
                                            _c("p", [
                                              _vm._v(
                                                "接收号码：" +
                                                  _vm._s(elem.target)
                                              )
                                            ])
                                          ])
                                        })
                                      : _vm._e(),
                                    item.signingTipsList &&
                                    item.signingTipsList.length
                                      ? _vm._l(item.signingTipsList, function(
                                          sign,
                                          i
                                        ) {
                                          return _c("div", { key: i }, [
                                            sign.signatoryFullName
                                              ? _c("p", [
                                                  _vm._v(
                                                    "指定签署方（" +
                                                      _vm._s(
                                                        sign.signatoryFullName
                                                      ) +
                                                      "）阅读并确认。"
                                                  )
                                                ])
                                              : _vm._e(),
                                            sign.signingTipsTitle
                                              ? _c("p", [
                                                  _vm._v(
                                                    "签署提示标题：" +
                                                      _vm._s(
                                                        sign.signingTipsTitle
                                                      )
                                                  )
                                                ])
                                              : _vm._e(),
                                            sign.signingTipsContent
                                              ? _c("p", [
                                                  _vm._v(
                                                    "已阅读并确认：" +
                                                      _vm._s(
                                                        sign.signingTipsContent
                                                      )
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        })
                                      : _vm._e()
                                  ]
                                : item.signType == 15
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("b", [_vm._v("身份认证")]),
                                    _c("p", [_vm._v("认证方式：短信验证码")]),
                                    _c("p", [
                                      _vm._v("认证信息：" + _vm._s(item.mobile))
                                    ]),
                                    _c("p", [_vm._v("验证成功.")])
                                  ]
                                : +item.signType === 16
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("p", [
                                      _vm._v("终端IP：" + _vm._s(item.ip))
                                    ]),
                                    item.userAgent && item.userAgent != ""
                                      ? _c("p", [
                                          _vm._v(
                                            "浏览器UA：" +
                                              _vm._s(item.userAgent)
                                          )
                                        ])
                                      : _vm._e(),
                                    item.addr
                                      ? _c("p", [
                                          _vm._v(
                                            "地理位置：" + _vm._s(item.addr)
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                : item.signType == 17
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("b", [_vm._v("保管函")]),
                                    _c("p", [
                                      _vm._v(
                                        "编号：" +
                                          _vm._s(
                                            _vm.getId(item.safeKeepLetterId)
                                          )
                                      )
                                    ])
                                  ]
                                : item.signType == 18
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    item.signingTipsContent
                                      ? _c("p", [
                                          _vm._v(
                                            "已阅读并确认：" +
                                              _vm._s(item.signingTipsContent)
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("p", [
                                      _vm._v(_vm._s(item.name) + "确认签署")
                                    ]),
                                    _c("p", [
                                      _vm._v("终端IP：" + _vm._s(item.ip))
                                    ]),
                                    item.addr
                                      ? _c("p", [
                                          _vm._v(
                                            "地理位置：" + _vm._s(item.addr)
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                : item.signType == 19
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("p", [_vm._v("身份认证")]),
                                    _c("p", [_vm._v("认证方式：运营商三要素")]),
                                    _c("p", [
                                      _vm._v("认证信息：" + _vm._s(item.mobile))
                                    ]),
                                    _c("p", [
                                      _vm._v("流水号:" + _vm._s(item.orderNo))
                                    ]),
                                    _c("p", [_vm._v("验证成功.")])
                                  ]
                                : item.signType == 20
                                ? [
                                    item.signType != 10 && item.createTime
                                      ? _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  item.createTime
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("p", [
                                      _vm._v("通知短信：" + _vm._s(item.mobile))
                                    ])
                                  ]
                                : item.signType == 21 || item.signType == 22
                                ? [
                                    _c(
                                      "ul",
                                      { staticClass: "verification_ul" },
                                      [
                                        item.signType == 21
                                          ? _c(
                                              "li",
                                              {
                                                staticClass: "verification_li"
                                              },
                                              [_vm._v("身份证二要素")]
                                            )
                                          : _vm._e(),
                                        item.signType == 22
                                          ? _c(
                                              "li",
                                              {
                                                staticClass: "verification_li"
                                              },
                                              [_vm._v("企业工商三要素")]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _c("p", [
                                      _vm._v(
                                        "\n              认证时间：" +
                                          _vm._s(
                                            _vm._f("formatDateTime")(
                                              !item.faceTime
                                                ? item.createTime
                                                : item.faceTime
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]),
                                    _c("p", [
                                      _vm._v("流水号:" + _vm._s(item.orderNo))
                                    ]),
                                    _c("p", [_vm._v("验证结果：校验成功")])
                                  ]
                                : item.signType === 24
                                ? [
                                    _c("h5", [_vm._v("签署短信信息")]),
                                    _c("p", [
                                      _vm._v("发送方名称：" + _vm._s(item.name))
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "发送方证件号：" +
                                          _vm._s(item.identityCard)
                                      )
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "短信发送时间：" +
                                          _vm._s(item.createTime)
                                      )
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "接收方名称：" +
                                          _vm._s(
                                            item.notify[0]
                                              ? item.notify[0].name
                                              : ""
                                          )
                                      )
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "接收方证件号：" +
                                          _vm._s(
                                            item.notify[0]
                                              ? item.notify[0].idNo
                                              : ""
                                          )
                                      )
                                    ])
                                  ]
                                : item.signType == 25
                                ? [
                                    _c("b", [_vm._v("AI鉴证")]),
                                    _c("br"),
                                    _c("p", [
                                      _vm._v(
                                        "认证时间：" + _vm._s(item.aiAuthTime)
                                      )
                                    ]),
                                    _c("p", [
                                      _vm._v("流水号:" + _vm._s(item.orderNo))
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "人脸识别相似度：" +
                                          _vm._s(item.similarity)
                                      )
                                    ]),
                                    _c("p", [_vm._v("AI鉴证结果：通过")])
                                  ]
                                : item.signType == 26
                                ? [
                                    _c("b", { staticClass: "high-light" }, [
                                      _vm._v("视频单录")
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "认证时间：" +
                                          _vm._s(
                                            _vm._f("formatDateTime")(
                                              item.asrTime
                                            )
                                          )
                                      )
                                    ]),
                                    _c("p", [
                                      _vm._v("流水号:" + _vm._s(item.orderNo))
                                    ]),
                                    _c("p", [_vm._v("语义是否一致：是")]),
                                    _c("p", [
                                      _vm._v(
                                        "相似度：" +
                                          _vm._s(item.similarity) +
                                          "%"
                                      )
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            : _c("div", { staticClass: "sdetails" }, [_vm._v("没有过程证据")])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b577e84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b577e84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/processEvidence/index.vue
// module id = 7uK8
// module chunks = 14 17 85